export const environment = {
  production: false,
  apiUrl: 'api',
  X_User_Id: 'X-User-Id',
  X_Auth_Token: 'X-Auth-Token',
  X_Refresh_Token: 'X-Refresh-Token',
  App_id: 'asdwww',
  chatUrl: 'https://api-support-chat.sentrixbar.com',
  wsChatUrl: 'wss://api-support-chat.sentrixbar.com/',
  appVersion: 'v1',
  CHAT_USER_KEY: 'support-user',
}
